export default function numberAlign(Vue) {
    Vue.directive('numberAlign', {
        bind(el, binding, vNode, oldVNode, isDestroy) {
            // if (isDestroy) return
            // console.log(vNode.elm.innerHTML, (oldVNode.elm && oldVNode.elm.innerHTML))
            // if (vNode.elm.innerHTML === (oldVNode.elm && oldVNode.elm.innerHTML)) return
            const fixed = (binding.value && binding.value.fixed) || 2
            const num = el.innerText.trim()
            num.replace(/^(-?)(\d+)(\.?)(\d+)?$/, function(match, $1, $2, $3, $4) {
                const wrapperContainer = document.createElement('span')
                vNode.key = Math.floor(Math.random() * 10000000) + Date.now()
                const leftEl = document.createElement('span')
                leftEl.innerText = $1 + $2
                wrapperContainer.appendChild(leftEl)
                if ($1) {
                    wrapperContainer.style.color = '#ee5b5b'
                }

                const rightEl = document.createElement('span')
                if (!$3) {
                    rightEl.innerText = '.' + '0'.repeat(fixed)
                    // rightEl.style.visibility = 'hidden'
                    wrapperContainer.appendChild(rightEl)
                } else {
                    rightEl.innerText = $3 + $4
                    if ($4.length < fixed) {
                        const span = document.createElement('span')
                        span.style.visibility = 'hidden'
                        span.innerText = '0'.repeat(fixed - $4.length)
                        rightEl.appendChild(span)
                    }
                    wrapperContainer.appendChild(rightEl)
                }

                el.innerHTML = ''
                el.appendChild(wrapperContainer)
            })
        }
    })
}
